module.exports = __webpack_public_path__ + "static/media/ci.01978355.svg";